@if (featureSet) {
  <div class="{{ngClass}}" (click)="onClick()">
    <div class="widget-top">
      <div class="icon">
        <i class="{{ icons.getIcon(featureSet['productCode']) }} widget-device-icon "></i>
      </div>
      <div class="widget-top-right">
        <p>{{batteryLevel.attributes.value}}%</p>
      </div>
    </div>
    <div class="widget-middle"></div>
    <div class="widget-bottom">
      <div class="widget-bottom-left">
        <div class="widget-name" matTooltip="{{ featureSet['name'].length >= 12 ? featureSet['name'] : ''}}"
          matTooltipPosition="after">
          <p>{{featureSet.name}}</p>
          <!-- <p class="device-room" *ngIf="getRoomName()">{{ getRoomName() }}</p> -->
        </div>
      </div>
    </div>
  </div>
}